import React, { createContext, useContext, useState, useEffect } from 'react';

export const ClipboardContext = createContext();

export const ClipboardProvider = ({ children }) => {
    const [clipboardItems, setClipboardItems] = useState([]);

    // 1. Cargar del localStorage al iniciar la app
    useEffect(() => {
        try {
            const saved = localStorage.getItem('medical_clipboard');
            if (saved) {
                setClipboardItems(JSON.parse(saved));
            }
        } catch (e) {
            console.error("Error cargando carrito:", e);
        }
    }, []);

    // 2. Guardar en localStorage cada vez que cambia el carrito
    useEffect(() => {
        localStorage.setItem('medical_clipboard', JSON.stringify(clipboardItems));
    }, [clipboardItems]);

    // --- ACCIONES ---

    const addToClipboard = (item) => {
        // Añadimos un ID único (cartId) para permitir duplicados si fuera necesario
        const itemWithId = { ...item, cartId: Date.now() + Math.random() };
        setClipboardItems(prev => [...prev, itemWithId]);
    };

    // La función interna se llama removeFromClipboard y espera un cartId
    const removeFromClipboard = (cartId) => {
        setClipboardItems(prev => prev.filter(item => item.cartId !== cartId));
    };

    const clearClipboard = () => {
        setClipboardItems([]);
    };

    return (
        <ClipboardContext.Provider value={{ 
            clipboardItems, 
            addToClipboard, 
            removeFromClipboard, 
            clearClipboard,
            // 🔥 CORRECCIÓN: Aliases 'removeItem' para que funcione en RecipesPage
            removeItem: removeFromClipboard 
        }}>
            {children}
        </ClipboardContext.Provider>
    );
};

export const useClipboard = () => useContext(ClipboardContext);